import { render, staticRenderFns } from "./height.vue?vue&type=template&id=1c964c25&scoped=true&"
import script from "./height.vue?vue&type=script&lang=ts&"
export * from "./height.vue?vue&type=script&lang=ts&"
import style0 from "./height.vue?vue&type=style&index=0&id=1c964c25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c964c25",
  null
  
)

export default component.exports